<template>
  <div v-bind:class="[authFlag == true ? 'login' : 'logout']">
    <main id="top" class="wrapper">
      <section class="keyVisual">
        <div class="keyVisualInner container">
          <h1>
            <picture>
              <source media="(min-width: 961px)" srcset="/assets/img/top/keyvTitle.png">
              <source media="(max-width: 960px)" srcset="/assets/img/top/keyvTitleSp.png">
              <img src="/assets/img/top/keyvTitle.png" alt="OTEX おかやまテクノロジー展2024 ONLINE 精鋭企業と出会う技術展示商談会" fetchpriority="high">
            </picture>
          </h1>
          <p class="keyVisualSubtitle">
            <img src="/assets/img/top/keyvSubtitle.svg" alt="未来を起動せよ。">
          </p>
          <div class="effectBlock effectBlock01"></div>
        </div>
      </section>
      <!-- .keyVisual -->

      <section id="about" class="topAbout topAboutLogout" v-show="true">
        <div class="topAboutInner container">
          <div class="effectBlock effectBlock06"></div>
          <h2 class="topAboutInnerTitle">
            <img src="/assets/img/top/aboutOtexTxtBlack.svg" alt="おかやまテクノロジー展 OTEXとは"><br/>
            <img src="/assets/img/top/aboutOtexTitleBlack.svg" alt="中四国最大級!ものづくり企業の展示商談会">
          </h2>
          <p>岡山県は、優れた技術や製品を持つ企業が多くあり、<br class="spNone">
            県内総生産のうち製造業の占める割合が全国平均を大きく上回る「ものづくり県」です。<br class="spNone">
            機械系ものづくり企業の展示商談会としては中四国最大級で、<br class="spNone">
            「ものづくり県おかやま」を広くアピールするため、2016年から開催。<br/>
            おかやまテクノロジー展2024をリアル展とあわせてオンラインで同時開催します。
          </p>
          <a class="linkSlash topSlideshowBtn">
            <picture>
              <source media="(min-width: 961px)" srcset="/assets/img/top/aboutOtexBtntextBlack.svg">
              <source media="(max-width: 960px)" srcset="/assets/img/top/aboutOtexBtntextSpBlack.svg">
              <img src="/assets/img/top/aboutOtexBtntextBlack.svg" alt="リアル展2024のスライドショーはこちら">
            </picture>
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </a>
          <div class="topAboutInnerImg">
            <img src="/assets/img/top/aboutImg01.png" alt="OTEX OKAYAMA TECHNOLOGY EXHIBITION" width="416" height="132">
          </div>
          <iframe class="topAboutInnerVideo" src="https://www.youtube.com/embed/ZiW9j9MzTkQ?si=bcifdhER-HeD6XDu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </div>
      </section>
      <!-- topAbout ※ログイン前のセクション用 -->

      <section class="secPickup">

        <div class="secPickupIntro container containerLarge">
          <h2 class="h01 h01Pickup">
            <span class="h01Inner">
              <span class="h01Jp"><img src="/assets/img/common/txtPickupWhite.svg" alt="ピックアップ企業" width="259" height="40" ></span>
              <span class="h01En"><img src="/assets/img/common/txtPickupEnWhite.svg" alt="PICKUP"></span>
            </span>
          </h2>
          <div class="effectBlock effectBlock02"></div>
        </div>
        <div class="secPickupBtnarea container containerLarge">
          <router-link to="/company/" class="linkSlash linkSlashWhite">
            企業情報一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#10151a" />
              </svg>
            </div>
          </router-link>
        </div>
        <div class="secPickupSlide jsSlide01 splide" >
          <div class="splide__track">
            <ul class="splide__list">

              <li class="splide__slide" v-for="company in pickupCompanies" :key="company.id">
                <router-link :to="`/companyDetail?company_id=${company.id}`" class="secPickupSlideBox">
                  <div class="secPickupSlideBoxImg">
                    <img v-if="company.background_image_path" :src="company.background_image_path" alt="" @error="companyAltImg">
                    <img v-else src="/assets/img/company/companyKeyvisual.jpg" alt="{企業名}" />
                  </div>
                  <span class="secPickupSlideBoxTag">{{company.industry_name}}</span>
                  <span class="secPickupSlideBoxTitle">{{company.company_name}}</span>
                </router-link>
              </li>
            </ul>
          </div>
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <img src="/assets/img/common/iconArrowSliderWhite.svg" alt="前へ">
            </button>
            <button class="splide__arrow splide__arrow--next">
              <img src="/assets/img/common/iconArrowSliderWhite.svg" alt="次へ">
            </button>
          </div>
        </div>
        <!-- slide -->
      </section>
      <!-- secPickup -->

      <div class="topSlideshow container">
        <iframe class="topSlideshowVideo" src="https://www.youtube.com/embed/ZiW9j9MzTkQ?si=bcifdhER-HeD6XDu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        <button class="topSlideshowBtn">
          <picture>
            <source media="(min-width: 961px)" srcset="/assets/img/top/otexSlideshowBanner.png">
            <source media="(max-width: 960px)" srcset="/assets/img/top/otexSlideshowBannerSp.png">
            <img src="/assets/img/top/otexSlideshowBanner.png" alt="">
          </picture>
        </button>
        <div class="effectBlock effectBlock03"></div>
      </div>
      <!-- topSlideshow -->

      <section class="topPresentation">
        <div class="topPresentationIntro container containerLarge">
          <h2 class="h01 h01Presentation">
            <span class="h01Inner">
              <span class="h01Jp">
                <picture>
                  <source media="(min-width: 961px)" srcset="/assets/img/common/txtShuttensya.svg">
                  <source media="(max-width: 960px)" srcset="/assets/img/common/txtShuttensyaSp.svg">
                  <img src="/assets/img/common/txtShuttensya.svg" alt="出展者プレゼンテーション" >
                </picture>
              </span>
              <span class="h01En"><img src="/assets/img/common/txtPresentation.svg" alt="PRESENTAITON" width="934" height="100" ></span>
            </span>
          </h2>
          <div class="effectBlock effectBlock05"></div>
        </div>
        <div class="topPresentationBtnarea container containerLarge">
          <router-link to="/presentation/" class="linkSlash linkSlash2row">
            出展者プレゼンテーション<br />一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </router-link>
        </div>

        <div class="topPresentationSlide jsSlide03 splide">
          <div class="splide__track">
            <ul class="splide__list">
              <li class="splide__slide" v-for="presentation in presentations" :key="presentation.id">
                <a v-bind:class="['linkPresentation', presentation.panel_color]" @click="displayPresentation(presentation.id)">
                  <div class="linkPresentationInner">
                    <span class="linkPresentationTitle">{{presentation.title}}</span>
                    <span v-bind:class="['linkPresentationTag', presentation.panel_color]">{{presentation.industry_name}}</span>
                    <span class="linkPresentationTxt">{{presentation.company_name}}</span>
                    <div class="linkPresentationTri linkPresentationTriLeft"></div>
                    <div class="linkPresentationTri linkPresentationTriRight"></div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div class="splide__arrows">
            <button class="splide__arrow splide__arrow--prev">
              <img src="/assets/img/common/iconArrowSlider.svg" alt="前へ">
            </button>
            <button class="splide__arrow splide__arrow--next">
              <img src="/assets/img/common/iconArrowSlider.svg" alt="次へ">
            </button>
          </div>
        </div>
      </section>
      <!-- topPresentation -->

      <section class="topKeyword">
        <div class="topKeywordIntro container containerLarge">
          <h2 class="h01 h01Keyword">
            <span class="h01Inner">
              <span class="h01Jp">
                <picture>
                  <source media="(min-width: 961px)" srcset="/assets/img/common/txtKeyword.svg">
                  <source media="(max-width: 960px)" srcset="/assets/img/common/txtKeywordSp.svg">
                  <img src="/assets/img/common/txtKeyword.svg" alt="キーワードから企業を探す" >
                </picture>
              </span>
              <span class="h01En"><img src="/assets/img/common/txtKeywordEn.svg" alt="KEYWORD" width="645" height="100"></span>
            </span>
          </h2>
        </div>
        <div class="topKeywordBtnarea container containerLarge">
          <router-link to="/company/" class="linkSlash">
            企業情報一覧はこちら
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#fff" />
              </svg>
            </div>
          </router-link>
        </div>
        <div class="topKeywordList container containerLarge">
          <ul>
            <li><router-link to="/company" class="linkTag cat1" @click="industrySearch(1)">切削・研削</router-link></li>
            <li><router-link to="/company" class="linkTag cat2" @click="industrySearch(2)">鋳造・鍛造</router-link></li>
            <li><router-link to="/company" class="linkTag cat3" @click="industrySearch(3)">溶接・製缶</router-link></li>
            <li><router-link to="/company" class="linkTag cat4" @click="industrySearch(4)">プレス・板金</router-link></li>
            <li><router-link to="/company" class="linkTag cat5" @click="industrySearch(5)">金型・治具</router-link></li>
            <li><router-link to="/company" class="linkTag cat6" @click="industrySearch(6)">表面処理・熱処理・塗装</router-link></li>
            <li><router-link to="/company" class="linkTag cat7" @click="industrySearch(7)">電気・電子機器組立</router-link></li>
            <li><router-link to="/company" class="linkTag cat8" @click="industrySearch(8)">樹脂成形・ゴム加工</router-link></li>
            <li><router-link to="/company" class="linkTag cat9" @click="industrySearch(9)">設計・ソフト</router-link></li>
            <li><router-link to="/company" class="linkTag cat10" @click="industrySearch(10)">工具</router-link></li>
            <li><router-link to="/company" class="linkTag cat11" @click="industrySearch(11)">その他</router-link></li>
            <li><router-link to="/company" class="linkTag cat12" @click="industrySearch(12)">FA機器</router-link></li>
            <li><router-link to="/company" class="linkTag cat13" @click="industrySearch(13)">検査・測定機器</router-link></li>
            <li><router-link to="/company" class="linkTag cat14" @click="industrySearch(14)">生産設備関連</router-link></li>
            <li><router-link to="/company" class="linkTag cat15" @click="industrySearch(15)">AI・IoT</router-link></li>
            <li><router-link to="/company" class="linkTag cat16" @click="industrySearch(16)">自社製品</router-link></li>
            <li><router-link to="/company" class="linkTag cat17" @click="industrySearch(17)">素材</router-link></li>
            <li><router-link to="/company" class="linkTag cat18" @click="industrySearch(18)">ものづくり関連商社・サービス</router-link></li>
            <li><router-link to="/company" class="linkTag cat19" @click="industrySearch(19)">共同出展事務局</router-link></li>
            <li><router-link to="/company" class="linkTag cat20" @click="industrySearch(20)">特別展示</router-link></li>
            <li><router-link to="/company" class="linkTag cat21" @click="industrySearch(21)">工作機械展示</router-link></li>
          </ul>
        </div>
      </section>
      <!-- topKeyword -->

      <section id="about" class="topAbout topAboutLogin" v-show="true">
        <div class="topAboutInner container">
          <div class="effectBlock effectBlock06"></div>
          <h2 class="topAboutInnerTitle">
            <img src="/assets/img/top/aboutOtexTxt.svg" alt="おかやまテクノロジー展 OTEXとは"><br/>
            <img src="/assets/img/top/aboutOtexTitle.svg" alt="中四国最大級!ものづくり企業の展示商談会">
          </h2>
          <p>岡山県は、優れた技術や製品を持つ企業が多くあり、<br class="spNone">
            県内総生産のうち製造業の占める割合が全国平均を大きく上回る「ものづくり県」です。<br class="spNone">
            機械系ものづくり企業の展示商談会としては中四国最大級で、<br class="spNone">
            「ものづくり県おかやま」を広くアピールするため、2016年から開催。<br/>
            おかやまテクノロジー展2024をリアル展とあわせてオンラインで同時開催します。
          </p>
          <a class="linkSlash linkSlashWhite topSlideshowBtn">
            <picture>
              <source media="(min-width: 961px)" srcset="/assets/img/top/aboutOtexBtntext.svg">
              <source media="(max-width: 960px)" srcset="/assets/img/top/aboutOtexBtntextSp.svg">
              <img src="/assets/img/top/aboutOtexBtntext.svg" alt="リアル展2024のスライドショーはこちら">
            </picture>
            <div class="linkSlashIcon">
              <svg xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7">
                <path d="M3.5,0,7,7H0Z" transform="translate(7) rotate(90)" fill="#10151a" />
              </svg>
            </div>
          </a>
        </div>
      </section>
      <!-- topAbout -->

      <div class="popup" id="jsPopup1">
        <div class="popupWrapper">
          <div class="popupInner">
            <div class="popupClose"><img src="/assets/img/common/iconPopupClose.svg" alt="閉じる" width="31" height="31"></div>
              <div class="topRealExhibition popupItem">
                <div class="topRealExhibitionTxt">
                  <p class="topRealExhibitionTitle"><img src="/assets/img/top/2024/realExhibitionTitle.svg" alt="おかやまテクノロジー展 2024 リアル展 スライドショー"></p>
                  <p>
                    OTEX2024リアル展は2日間で過去最高となる延べ12,580人にご来場いただき、好評の内に終了いたしました。多数のご来場ありがとうございました。
                  </p>
                  <dl>
                    <dt>開催日時</dt>
                    <dd>2024年11月13日 ～ 2024年11月14日</dd>
                    <dt>会場</dt>
                    <dd>コンベックス岡山 大・中・小展示場</dd>
                  </dl>
                </div>
                <div class="topRealExhibitionSlide">
                  <div class="topPresentationSlide jsSlide04 splide">
                    <div class="splide__track">
                      <ul class="splide__list">
                        <li class="splide__slide">
                          <img src="/assets/img/top/event_hall_partial_view.JPG?241220" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/company_booth.JPG?241220" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/keynote_speech.JPG?241220" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/presentation.JPG?241220" alt="">
                        </li>
                        <li class="splide__slide">
                          <img src="/assets/img/top/exhibition_hall_full_view.JPG?241220" alt="">
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!-- slide -->
              </div>
              <!-- item -->
            </div>
            <!-- inner -->
          </div>
        </div>
        <div class="popupBg"></div>
      <!-- popup slideshow -->
    </main>
  </div>
</template>

<script setup>
  import { ref, onMounted, inject, watch, computed, onBeforeMount } from 'vue';
  import Splide from '@splidejs/splide';
  import FlashMessage from "../../components/FlashMessage.vue";
  import { onBeforeRouteLeave } from 'vue-router';
  import { useStore } from 'vuex';
  import router from '@/router';
  import axios from 'axios';

  //store/index.jsのグローバルデータ
  const store = useStore();
  //main.jsで定義したグローバルaxios
  const $axios = inject('$axios');
  //変数
  const authFlag = computed(() => store.state.authFlag);
  const pickupCompanies = ref([]);
  const lectures = ref([]);
  const presentations = ref([]);
  const notifications = ref([]);
  let splide1;
  let splide2;
  let splide3;
  let splideNews;
  let splide4;

  //関数
  //ピックアップ企業の取得
  const fetchPickUpCompany = () => {
    $axios.get('/api/get_pickup_companies')
      .then(res => {
        console.log(res.data.companies);
        pickupCompanies.value = res.data.companies;
      })
      .catch(err => {
        console.error(err);
      })
      .finally(()=> {
       
        splide1 = new Splide(".jsSlide01", { 
          updateOnMove: true,
          type: "loop",
          arrows: true,
          pagination: false,
          perPage: 3,
          perMove: 1,
          focus: "center",
          trimSpace: false,
          flickPower: 100,
          interval: 5000,
          speed: 400,
          autoplay: true,
          breakpoints: {
            960: {
              perPage: 1,
            },
          },
        });
        splide1.mount();

      });
  };

  //基調講演の取得
  const fetchUpLectures = () => {
    $axios.get('/api/get_pickup_lectures')
      .then(res => {
        console.log(res.data.lectures);
        lectures.value = res.data.lectures;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {

        let jsSlide02 = document.querySelector('.jsSlide02');
        if(jsSlide02) {
          splide2 = new Splide(".jsSlide02", { 
            arrows: true,
            pagination: false,
            perMove: 1,
            pagination: true,
            trimSpace: false,
            flickPower: 300,
            fixedWidth: 580,
            gap: 40,
            breakpoints: {
              960: {
                fixedWidth: false,
                perPage: 1,
              },
            },
          });
          splide2.mount();
        }

      });
  }

  //出展者プレゼンテーションの取得
  const fetchUpPresentations = () => {
    $axios.get('/api/get_pickup_presentations')
      .then(res => {
        console.log(res.data.presentations);
        presentations.value = res.data.presentations;
      })
      .catch(err => {
        console.log(err);
      })
      .finally(()=> {

        let jsSlide03 = document.querySelector('.jsSlide03');
        if(jsSlide03) {
          splide3 = new Splide(".jsSlide03", { 
              arrows: true,
              perMove: 1,
              pagination: true,
              trimSpace: false,
              flickPower: 300,
              fixedWidth: 380,
              gap: 40,
              breakpoints: {
                960: {
                  fixedWidth: false,
                  perPage: 1,
                },
              },
          });
          splide3.mount();
        }
      });
  }

  //popup リアル展スライドショー
  const topSlideshowPopup = (e, btn) => {
    var popup = document.getElementById(e);
    if (!popup) return;
    var blackBg = document.querySelector(".popupBg");
    var closeBtn = document.querySelector(".popupClose");
    var showBtn = document.querySelectorAll(btn);
    showBtn.forEach(function (e) {
      e.addEventListener(
        "click",
        () => {
          popup.classList.toggle("popupShow");
          if (popup.classList.contains("popupShow") == true) {
            document.body.style.overflowY = "hidden";
          } else {
            document.body.style.overflowY = "auto";
          }
        },
        false
      );
    });

    function togglePopUp(elem) {
      if (!elem) return;
      elem.addEventListener("click", function () {
        popup.classList.toggle("popupShow");
        if (popup.classList.contains("popupShow") == true) {
          document.body.style.overflowY = "hidden";
        } else {
          document.body.style.overflowY = "auto";
        }
      });
    }

    togglePopUp(blackBg);
    togglePopUp(closeBtn);

  }

  //ニュースバーの情報取得
  const fetchNotifications = () => {
  }

  //基調講演を押した時ページ遷移して表示させる処理
  const displayLecture = (lecture) => {

    //video_urlが設定されてなければこの後の処理は発火しない
    if (!lecture.video_url) {
      console.log('video_urlがないので遷移なし');
      return;
    }

    store.commit('setTopPageLectureInfo', lecture);
    router.push('/lecture');
  }

  //プレゼンテーションを押した時ページ遷移して表示させる処理
  const displayPresentation = (presentationId) => {
    store.commit('setTopPagePresentationFlagNum', presentationId);
    router.push('/presentation');
  }

  //キーワードから検索のところの処理（カテゴリー検索）
  const industrySearch = (num) => {
    store.commit('setIndustryTopSearch', "industry_check_" + num);
  }

  const companyAltImg = (event) => {
    event.target.src = "/assets/img/top/pickupThumb03.jpg"; 
  }

  const lectureAltImg = (event) => {
      event.target.src = "/assets/img/top/lectureImg01.jpg"; 
  }

  const gtagAccessTopPage = () => {
  }

  // 学生アカウントのログを送信する
  const gtagStudentTopPage = () => {
  }

  //mountedより前に発火
	onBeforeMount(() => {
    fetchPickUpCompany();
    fetchUpLectures();
    fetchUpPresentations();
    fetchNotifications();
  })
  // mounted 
  onMounted(() => {
    topSlideshowPopup("jsPopup1", ".topSlideshowBtn");
    //※splideの初期化はmounted内で定義しないとうまくいかないのでこのように対応
    splide4 = new Splide(".jsSlide04", { 
      arrows: false,
      perMove: 1,
      pagination: true,
      trimSpace: false,
      flickPower: 300,
      interval: 5000,
      speed: 400,
      autoplay: true,
    });
    splide4.mount();

    //重複初期化を避けるために要素をページ離脱前に削除
    onBeforeRouteLeave((to, from, next) => {
      setTimeout(() => {
        splide1.destroy();
        splide4.destroy();
        //splide2 && splide3はログアウト中は存在しないので除外
        if (splide2 && splide3) {
          splide2.destroy();
          splide3.destroy();
        }
        if (splideNews) {
          splideNews.destroy();
        }
      }, 1000);

      next();
    });
  });
</script>